import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Modal, Select } from 'semantic-ui-react';
import {
  AvailableUser,
  TeamMemberData,
} from '../providers/TeamMembersProvider';
import { copyObject } from '../utility';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';
import Typography from './Typography';

export interface IAddTeamMemberModal {
  open: boolean;
  initialValues: TeamMemberData;
  isAdd: boolean;
  availableUsers: AvailableUser[];

  onSubmit(_values: TeamMemberData): void;
  onCancel(): void;
}

const AddTeamMemberModal = (props: IAddTeamMemberModal) => {
  const { initialValues, open, isAdd, availableUsers, onSubmit, onCancel } =
    props;

  const [values, setValues] = useState<TeamMemberData>();
  const [chosenUser, setChosenUser] = useState<AvailableUser | undefined>();

  const { t } = useTranslation();


  useEffect(() => {
    setValues(initialValues);
    if(initialValues && initialValues.id) {
      setChosenUser({
          id: initialValues.id,
          firstName: initialValues.firstName,
          lastName: initialValues.lastName,
          email: initialValues.email,
      })
    }
  }, [initialValues]);

  const handleToggleCheck = (_e: any, data: any) => {
    let copy = copyObject(values);
    copy[data.name] = data.checked;
    setValues(copy);
  };

  const handleSelectUser = (_e: any, data: any) => {
    const user = availableUsers.find((u) => u.id === data.value);
    if (user) {
      let copy = copyObject(values);
      copy.firstName = user.firstName;
      copy.lastName = user.lastName;
      copy.email = user.email;
      copy.userId = user.id;

      setValues(copy);
      setChosenUser(user);
    }
  };

  const handleCancel = () => {
    setChosenUser(undefined);
    onCancel();
  };

  const selectMap = availableUsers.map((user) => {
    return {
      key: user.id,
      value: user.id,
      text: `${user.firstName} ${user.lastName} (${user.email})`,
    };
  });

  if (values) {
    return (
      <Modal open={open} as={Form} style={{ width: 600 }}>
        <Modal.Header>
          {values.id
            ? t('teamMembers.editTeamMember')
            : t('teamMembers.addNewTeamMember')}
        </Modal.Header>
        {isAdd && !chosenUser ? (
          <Modal.Content>
            <Select
              placeholder={t('teamMembers.selectUser')}
              options={selectMap}
              onChange={handleSelectUser}
              fluid
            />
            <FlexRow fullWidth right padTop={15}>
              <Form.Button onClick={handleCancel} color="grey">
                {t('general.cancel')}
              </Form.Button>
            </FlexRow>
          </Modal.Content>
        ) : (
          <Modal.Content>
            <FlexRow padBottom={15}>
              <Typography variant="label" style={{ fontWeight: 800 }}>
                {t('teamMembers.user')}:
              </Typography>
            </FlexRow>
            <FlexRow baseline>
              <Typography variant="label">{t('teamMembers.name')}:</Typography>
              <Typography variant="label" style={{ paddingLeft: 6 }}>
                {isAdd
                  ? `${chosenUser?.firstName} ${chosenUser?.lastName}`
                  : `${values.firstName} ${values.lastName}`}
              </Typography>
            </FlexRow>
            <FlexRow baseline padBottom={15}>
              <Typography variant="label">{t('teamMembers.email')}:</Typography>
              <Typography variant="label" style={{ paddingLeft: 6 }}>
                {isAdd
                  ? `${chosenUser?.email}`
                  : `${values.firstName} ${values.lastName}`}
              </Typography>
            </FlexRow>
            <FlexRow padBottom={15}>
              <Typography variant="label" style={{ fontWeight: 800 }}>
                {t('teamMembers.policies')}:
              </Typography>
            </FlexRow>
            <Form.Field
              control={Checkbox}
              name="teamAdmin"
              label={t('teamMembers.teamAdmin')}
              checked={values.teamAdmin}
              onChange={handleToggleCheck}
            />
            <Form.Field
              control={Checkbox}
              name="configAdmin"
              label={t('teamMembers.configAdmin')}
              checked={values.configAdmin}
              onChange={handleToggleCheck}
              disabled={values.teamAdmin}
            />
            <Form.Field
              control={Checkbox}
              name="teamMemberAdmin"
              label={t('teamMembers.teamMemberAdmin')}
              checked={values.teamMemberAdmin}
              onChange={handleToggleCheck}
              disabled={values.teamAdmin}
            />
            <Form.Field
              control={Checkbox}
              name="canCheckOut"
              label={t('teamMembers.canCheckOut')}
              checked={values.canCheckOut}
              onChange={handleToggleCheck}
              disabled={values.teamAdmin}
            />
            <Form.Field
              control={Checkbox}
              name="canCreate"
              label={t('teamMembers.canCreate')}
              checked={values.canCreate}
              onChange={handleToggleCheck}
              disabled={values.teamAdmin}
            />
            <Form.Field
              control={Checkbox}
              name="canDelete"
              label={t('teamMembers.canDelete')}
              checked={values.canDelete}
              onChange={handleToggleCheck}
              disabled={values.teamAdmin}
            />
            <FlexRow fullWidth right>
              <Form.Button onClick={handleCancel} color="grey">
                {t('general.cancel')}
              </Form.Button>
              <Form.Button
                onClick={() => {
                  onSubmit(values);
                  setChosenUser(undefined);
                }}
                color="green"
              >
                {t('general.save')}
              </Form.Button>
            </FlexRow>
          </Modal.Content>
        )}
        )
      </Modal>
    );
  } else {
    return <div />;
  }
};

export default AddTeamMemberModal;
